import { useEffect, useState } from 'react';

import { get, keyBuilder, set } from '@/react/hooks/useLocalStorage';

const LOGOUT_REASON_KEY = 'logout_reason';

export function setLogoutReason(reason: string | undefined): void {
  if (!reason) {
    return;
  }
  set(LOGOUT_REASON_KEY, reason);
}

export function useLogoutReason(): string {
  const [reason] = useState(() => get<string>(LOGOUT_REASON_KEY, ''));

  useEffect(() => {
    if (reason) {
      localStorage.removeItem(keyBuilder(LOGOUT_REASON_KEY));
    }
  }, [reason]);

  return reason;
}
